import React from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'reactstrap';


// Purely imperative, because I honestly think it suits modals windows more
class ModalsManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      fade: false,
      Content: null,
      onConfirmCallback: () => {},
      additionalData: null,
      overrideClassName: null,
    };
  }

  componentDidUpdate() {
    const { fade } = this.state;
    if (fade) {
      setTimeout(() => {
        this.setState({
          fade: false,
        });
      }, 1000);
    }
  }

  open = (
    Content,
    onConfirm = () => {},
    additionalData = null,
    overrideClassName = null,
  ) => {
    this.setState({
      isOpen: true,
      fade: true,
      Content,
      onConfirmCallback: onConfirm,
      additionalData,
      overrideClassName,
    });
  }

  setError = (e, ...params) => {
    this.setState(oldState => ({
      ...oldState,
      additionalData: oldState.additionalData ? {
        ...oldState.additionalData,
        alertError: e,
        confirmParams: { ...params },
      } : {
        alertError: e,
        confirmParams: { ...params },
      },
    }));
  }

  onConfirm = (...params) => {
    const { onConfirmCallback } = this.state;
    onConfirmCallback(...params).then(this.onHide).catch(e => {
      this.setError(e, ...params);
    });
  }

  onHide = () => {
    this.setState({ isOpen: false });
  }

  render() {
    const {
      isOpen, fade, Content, additionalData, overrideClassName,
    } = this.state;

    const ModalComponent = () => (
      <Modal
        centered
        isOpen={isOpen}
        toggle={this.onHide}
        fade={fade}
        className={overrideClassName}
      >
        <Content
          onConfirm={this.onConfirm}
          onHide={this.onHide}
          additionalData={additionalData}
        />
      </Modal>
    );

    return ReactDOM.createPortal(
      <ModalComponent />,
      document.getElementById('modal'),
    );
  }
}

export default ModalsManager;

export const ModalManagerContext = React.createContext();
